import axios from "axios";
import { getApiUrl } from "../config/api";

export const checkTokenValidity = async () => {
	const token = localStorage.getItem("token");
	if (!token) return false;

	try {
		await axios.get(getApiUrl("/me"), {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return true;
	} catch (error) {
		if (error.response?.status === 401) {
			localStorage.removeItem("token");
		}
		return false;
	}
};
